module.exports = __webpack_public_path__ + "static/img/k4.54e5cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/k4.png
// module id = BFAk
// module chunks = 1